import React, { useState, useEffect, useRef } from "react";
import { motion } from "framer-motion";
import { useNavigate, useLocation, useOutletContext } from "react-router-dom";
import { get_summary_report, init_simulation } from '../services/api';
import { rootRoute } from "../../../config";
import { errorMsg } from "../../../helper/helpers";
import info from '../assets/info.png';
import General_feedback_active from "../assets/General_feedback_active.png";
import General_feedback_deactive from "../assets/General_feedback_deactive.png";
import Financial_analysis_active from "../assets/Finacial_analysis_active.png";
import Financial_analysis_deactive from "../assets/Financial_analysis_deactive.png";
import order_analysis_active from "../assets/order_analysis_active.png";
import order_analysis_deactive from "../assets/order_analysis_deactive.png";
import Button from '../../common/Button'
import leftArrow from "../assets/leftArrow.png";
import rightArrow from "../assets/rightArrow.png";
import prevArrow from "../assets/prevArrow.png";
import FcModuleStyle from '../styles/fc.module.css';
import CostAnalysisGraph from "./CostAnalysisGraph";
import RevenueGraph from "./RevenueGraph";
import MeanAPEGraph from "./MeanAPEGraph";
import DemandAnalysis from "./DemandAnalysis";

const Summary = () => {
  const location = useLocation();
  const navigate = useNavigate();
  var currentDate = new Date();
  var currentYear = currentDate.getFullYear();

  const queryParams = new URLSearchParams(location.search);

  const [summaryReports, setSummaryReports] = useState({});
  const [simulationDetailSummary, setSimulationDetailSummary] = useState([]);
  const [attempt, setAttempt] = useState(queryParams.get("attempt"));
  const [pagination, setPagination] = useState({ "prev": false, "next": false });
  const [simPopup, setSimPopup, isOverlay, setIsOverlay, headerPopup, setHeaderPopup, isArtifacts, setIsArtifacts, plPopup, setPlPopup, ulPopup, setUlPopup, simPrgPopup, setSimPrgPopup, skipWalkThruPopups, isPopupShown, setIsPopupShown, accordionPopup, setAccordionPopup, simObj, setSimObj, getMonth, toggleSimulation, setToggleSimulation, startOverSimulation, isLoader, setIsLoader, setAriaProperty, check_Location, setError] = useOutletContext();
  const [isActive, setIsActive] = useState("generalFeedback");
  const [executioninstanceid, setExecutioninstanceid] = useState("");
  const [page, setPage] = useState(1);
  const [pageHeight, setPageHeight] = useState("");
  const [optionsAvailableLength, setoptionsAvailableLength] = useState(0)
  const summaryBtnStyle = { color: "white", borderRadius: "40px", margin: "0px", padding: "16px 55px", fontSize: "16px" };
  const noOfRatings = [1, 2, 3, 4, 5];
  const starRating = Number(summaryReports?.FinancialAnalysis?.starRating);
  const TargetSR = Number(summaryReports?.FinancialAnalysis?.targetStarRating);
  const [isStyleTagPresent, setIsStyleTagPresent] = useState(false); //Added for stylus tool text-spacing change

  let session_id = queryParams.get("sid");
  let resource_id = queryParams.get("resid");
  let course_id = queryParams.get("cid");
  let user_id = queryParams.get("userid");
  let attempt_id = queryParams.get("attempt");
  let role = queryParams.get("role");

  const formatNum = (number) => {
    let formattedNumber = number?.toString();
    formattedNumber = formattedNumber?.includes('.') ? formattedNumber?.replace(/\.?0*$/, '') : formattedNumber;
    return formattedNumber;
  }
  const checkNum = (num) => {
    return (!isNaN(num)) ? (num < 0
      ? `-${Math?.abs(num)?.toLocaleString(undefined, {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      })}`
      : `${num?.toLocaleString(undefined, {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      })}`) : "";
  };
  const handleSetActive = (e) => {
    const generalFeedbackOffset =
      document.getElementById(`${FcModuleStyle.generalFeedback}`).offsetTop - 20;
    const demandAnalysisOffset =
      document.getElementById(`demandAnalysis`).offsetTop - 20;
    const forecastingAnalysisOffset =
      document.getElementById(`forecastingAnalysis`).offsetTop - 20;

      if (e.type === "click") {
        if (e.currentTarget.classList.contains("generalFeedbackParent")) {
          document.getElementById(`${FcModuleStyle.generalFeedback}`).querySelector("h2").tabIndex = -1;
          document.getElementById(`${FcModuleStyle.generalFeedback}`).querySelector("h2").focus();
          if (document.querySelector(`.${FcModuleStyle['summary-content-box']}`) != null) {
            document.querySelector(`.${FcModuleStyle['summary-content-box']}`).scrollTop =
              generalFeedbackOffset - 20;
          }
        } else if (e.currentTarget.classList.contains("forecastingAnalysisParent")) {
          document.querySelector(`#forecastingAnalysis h2`).tabIndex = -1;
          document.querySelector(`#forecastingAnalysis h2`).focus();
          if (document.querySelector(`.${FcModuleStyle['summary-content-box']}`) != null) {
            document.querySelector(`.${FcModuleStyle['summary-content-box']}`).scrollTop =
              forecastingAnalysisOffset - 0;
          }
  
        } else if (
          e.currentTarget.classList.contains("demandAnalysisParent")
        ) {
          document.querySelector(`#demandAnalysis h2`).tabIndex = -1;
          document.querySelector(`#demandAnalysis h2`).focus();
          if (document.querySelector(`.${FcModuleStyle['summary-content-box']}`) != null) {
          document.querySelector(`.${FcModuleStyle['summary-content-box']}`).scrollTop =
            demandAnalysisOffset - 0;
          }
        }
      }
    const scrollPosition = e.currentTarget.scrollTop;

    if (
      scrollPosition >= generalFeedbackOffset &&
      scrollPosition < demandAnalysisOffset
    ) {
      document.querySelector(`.generalFeedbackParent `).blur();
      setIsActive("generalFeedback");
    } else if (
      scrollPosition >= demandAnalysisOffset &&
      scrollPosition < forecastingAnalysisOffset
    ) {
      document.querySelector(`.demandAnalysisParent `).blur();
      setIsActive("demandAnalysis");
    } else if (scrollPosition >= forecastingAnalysisOffset) {
      document.querySelector(`.forecastingAnalysisParent `).blur();
      setIsActive("forecastingAnalysis");
    }
  };
  const navigateToSimulation = () => {
    navigate(rootRoute + "/fc/simulation");
  };
  const handlePopupExitSim = (e) => {
    window.close();
  }
  const initSummary = () => {
    (simObj?.status != 'COMPLETED' && (attempt == undefined && user_id == undefined)) && navigate(`${rootRoute}/fc/simulation`);
    window.$("html, body").animate({ scrollTop: 0, }, 100);
  };
  const backToSimulationList = () => {
    setIsLoader(true);
    if (role == "student") {
      navigate(rootRoute + `/fc/studentreview?${queryParams}`);
    } else {
      navigate(rootRoute + `/fc/instructorreview?${queryParams}`);
    }
  }
  const getNextAttempt = () => {
    setIsLoader(true);
    let index = simulationDetailSummary?.findIndex((sdObj) => sdObj.attemptno == attempt);
    let currSdSObj = simulationDetailSummary[index + 1];
    if (currSdSObj != undefined) {
      setAttempt(currSdSObj.attemptno);
      queryParams.set("attempt", currSdSObj.attemptno);
      setExecutioninstanceid(currSdSObj?.executioninstanceid);
      (simulationDetailSummary[index + 2] != undefined) ? setPagination({ "prev": true, "next": false }) : setPagination({ "prev": false, "next": true });
    } else {
      setPagination({ "prev": false, "next": true });
      setIsLoader(false);
    }
  }
  const getPrevAttempt = () => {
    setIsLoader(true);
    let index = simulationDetailSummary?.findIndex((sdObj) => sdObj.attemptno == attempt);
    let currSdSObj = simulationDetailSummary[index - 1];
    if (currSdSObj != undefined) {
      setAttempt(currSdSObj.attemptno);
      queryParams.set("attempt", currSdSObj.attemptno);
      setExecutioninstanceid(currSdSObj?.executioninstanceid);
      (simulationDetailSummary[index - 2] != undefined) ? setPagination({ "prev": false, "next": false }) : setPagination({ "prev": true, "next": false });
    } else {
      setPagination({ "prev": true, "next": false });
      setIsLoader(false);
    }
  }
  const OnLoadPagination = () => {
    let lastObjIndex = simulationDetailSummary?.length - 1;
    let firstObjIndex = 0;
    let currentIndex = simulationDetailSummary?.findIndex((sdObj) => sdObj.attemptno == attempt);
    (currentIndex == lastObjIndex) && setPagination({ "prev": false, "next": true });
    (currentIndex == firstObjIndex) && setPagination({ "prev": true, "next": false });
    if ((currentIndex != lastObjIndex) && (currentIndex != firstObjIndex)) {
      setPagination({ "prev": false, "next": false });
    }
  }
  const getSimulationDetailSummary = () => {
    setSimulationDetailSummary((attempt != undefined && user_id != undefined) ? simObj?.simulationdetails : []);
    setIsLoader(false);
  };
  const updateExcutionInstanceId = () => {
    if (attempt != undefined && user_id != undefined) {
      setExecutioninstanceid(simulationDetailSummary?.filter((sdObj) => sdObj.attemptno == attempt)[0]?.executioninstanceid)
    } else {
      setExecutioninstanceid(simObj?.executioninstanceid)
    }
  }
  const getSummaryReport = () => {
    ((simObj?.sessionid != undefined || session_id != undefined) && executioninstanceid != undefined && executioninstanceid.length > 0) && get_summary_report((simObj?.sessionid || session_id), executioninstanceid).then(
      (response) => {
        if (response.status === 500 && response?.data?.hasOwnProperty("id") && response?.data?.hasOwnProperty("msg")) {
          setError(response?.data)
      }
      else{
        setSummaryReports(response?.data);
        //console.log(response.data)
        OnLoadPagination();
        setIsLoader(false);
      }
      }).catch((error) => {
        // setError(errorMsg);
        setError({"id":"00000","msg":errorMsg})
        console.log(error);
      });
  };
  const generalClickHandler = (e) => {
    if (window.innerWidth > 570) {
      e.preventDefault();
      document.querySelector(".generalFeedbackParent").click();
      e.stopPropagation();
    }
    return 0;
  }
  const demandClickHandler = (e) => {
    if (window.innerWidth > 570) {
      e.preventDefault();
      document.querySelector(".demandAnalysisParent").click();
      e.stopPropagation();
    }
    return 0;
  }
  const forecastingClickHandler = (e) => {
    if (window.innerWidth > 570) {
      e.preventDefault();
      document.querySelector(".forecastingAnalysisParent").click();
      e.stopPropagation();
    }
    return 0;
  }
  useEffect(() => {
    setIsLoader(true);
    if (session_id != "" && simObj?.laststate == undefined) {//&& queryParams.get("sid") == undefined
      //setError(null);
      init_simulation(session_id).then(function (response) {
        if (response.status === 500 && response?.data?.hasOwnProperty("id") && response?.data?.hasOwnProperty("msg")) {
          setError(response?.data)
      }
      else{
        // console.log(response.data);
        setSimObj(Object.assign(response?.data, { "simulationdetails": simObj?.simulationdetails }));
        setError(null);
      }
      }).catch((error) => {
        // setError(errorMsg);
        setError({"id":"00000","msg":errorMsg})
      })
    }
    setIsOverlay(false);
  }, [])
  useEffect(()=>{
    if(summaryReports?.optionsAvailable){
    // debugger;
      let optionsLength = Object?.values(summaryReports?.optionsAvailable)?.reduce((a,b)=>a+b,0)
      setoptionsAvailableLength(optionsLength);
    }
  },[summaryReports?.optionsAvailable])
  useEffect(() => { updateExcutionInstanceId(); }, [simulationDetailSummary])
  useEffect(() => { getSimulationDetailSummary(); }, [attempt])
  useEffect(() => { getSummaryReport(); }, [executioninstanceid])
  useEffect(() => {
    if(document.querySelector("header.header") != null){
      document.querySelector("header.header").style.display = "none";
    }
    if(document.querySelector(".App .row") != null){
      document.querySelector(".App .row").style.minHeight = "auto";
    }
    setIsLoader(true);
    initSummary();
    setAttempt(queryParams.get("attempt"))
    document.querySelector(`.${FcModuleStyle['summary-container']} header.header h1`).tabIndex = -1;
    document.querySelector(`.${FcModuleStyle['summary-container']} header.header h1`).focus();
    const summaryPageHeight = window.innerHeight - document.querySelector(`.${FcModuleStyle['summary-container']} header.header`).clientHeight - document.getElementsByClassName(`${FcModuleStyle['summary-footer']}`)[0].clientHeight - document.querySelector(`.footer`).clientHeight;
    setPageHeight(summaryPageHeight - 1);
    if(window.innerWidth <= 778 && window.innerHeight < 335 ){
      setPageHeight(500);
    }

    document.title = "Forecasting | Summary";

    if (attempt != undefined && user_id != undefined) {
      // if (document.querySelector("footer.footer .footer-nav .footer-links") != null) {
      //   document.querySelector("footer.footer .footer-nav .footer-links").style.display = "none";
      // }
      // if (document.querySelector("footer.footer .container") != null) {
      //   document.querySelector("footer.footer .container").style.justifyContent = "center";
      // }
      if (document.querySelector("footer.footer .footer-nav .footer-links") != null) {
        document.querySelector("footer.footer .footer-nav .footer-links").firstChild.style.display = "none";
      }
    }

    return () => {
      if(document.querySelector("header.header") != null){
        document.querySelector("header.header").style.display = "block";
      }
      if(document.querySelector(".App .row") != null){
        document.querySelector(".App .row").style.minHeight = "100vh";
      }

      if (attempt != undefined && user_id != undefined) {
        if (document.querySelector("footer.footer .footer-nav .footer-links") != null) {
          document.querySelector("footer.footer .footer-nav .footer-links").style.display = "block";
        }
        if (document.querySelector("footer.footer .container") != null) {
          document.querySelector("footer.footer .container").style.justifyContent = "space-between";
        }
      }

    };
  }, [simObj?.sessionid || session_id]);

  //Added for stylus tool
  useEffect(() => {
    const checkStyleTag = () => {
      const styleTag = document.querySelector('style.stylus');
      setIsStyleTagPresent(!!styleTag);  // Updates the state to true if the tag is found, false otherwise
    };
    checkStyleTag();
    // Optionally, if the tag might be dynamically added, use a MutationObserver or setInterval
    const intervalId = setInterval(checkStyleTag, 500); // Check every 500ms
    return () => clearInterval(intervalId);  // Clean up interval when component unmounts
  }, []);

  return (
    <motion.div className={`${FcModuleStyle['summary-container']}`} id={`${isStyleTagPresent ? `${FcModuleStyle['fcSummaryStylus']}` : ''}`} initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5 }} >
      <header className={`header ${FcModuleStyle.header}`}>
        <div className={`container ${FcModuleStyle.container}`}>
          <div className={`${FcModuleStyle['icon-header-box']}`}>
            {
              (attempt != undefined && user_id != undefined) && <button onClick={backToSimulationList}><img src={prevArrow} /></button>
            }
            <h1 className={`ui header title ${FcModuleStyle.ui} ${FcModuleStyle.header} ${FcModuleStyle.title}`}>
              {attempt != undefined ? `Summary Report(Attempt ${attempt})` : "The year is over! Review your results below."}
            </h1>
          </div>
          {
            (attempt != undefined && user_id != undefined && simulationDetailSummary?.length != 1) && <div className={`${FcModuleStyle['pagination-icons']}`}>
              <button disabled={pagination.prev} onClick={getPrevAttempt}><img src={leftArrow} /></button>
              <button disabled={pagination.next} onClick={getNextAttempt}><img src={rightArrow} /></button>
            </div>
          }
        </div>
      </header>
      <div className={`ui stackable two column grid ${FcModuleStyle.ui} ${FcModuleStyle.stackable} ${FcModuleStyle.column} ${FcModuleStyle.grid} ${FcModuleStyle['summary-content']} `}>
        <div className={`column ${FcModuleStyle.column} ${FcModuleStyle['navigation-tab']}`}>
          <ul className={`ui link list ${FcModuleStyle.ui} ${FcModuleStyle.link} ${FcModuleStyle.list}`}>
            <li className={`item generalFeedbackParent ${FcModuleStyle['item']} ${isActive === "generalFeedback" ? `${FcModuleStyle['active']}` : ""}`}
              onClick={(e) => {
                handleSetActive(e);
                setIsActive("generalFeedback");
                // e.target.focus();
                e.stopPropagation();
              }}
              onKeyDown={(e) => {
                if (e.key == "Enter") {
                  e.target.click();
                }
              }}
              // tabIndex={`${isActive === "generalFeedback" ? -1 : 0}`}
              tabIndex={0}>
              <a href={`#${FcModuleStyle.generalFeedback}`} onClick={generalClickHandler} tabIndex={-1}>
                <img src={isActive === "generalFeedback" ? General_feedback_active : General_feedback_deactive} alt="" />
                <span>GENERAL FEEDBACK</span>
              </a>
            </li>
            <li className={`item demandAnalysisParent ${FcModuleStyle['item']} ${isActive === "demandAnalysis" ? `${FcModuleStyle['active']}` : ""}`}
              onClick={(e) => {
                handleSetActive(e);
                setIsActive("demandAnalysis");
                // e.target.focus();
                e.stopPropagation();
              }}
              onKeyDown={(e) => {
                if (e.key == "Enter") {
                  e.target.click();
                }
              }}
              // tabIndex={`${isActive === "demandAnalysis" ? -1 : 0}`}
              tabIndex={0}>
              <a href={`#demandAnalysis`} onClick={demandClickHandler} tabIndex={-1}>
                <img src={isActive === "demandAnalysis" ? order_analysis_active : order_analysis_deactive} alt="" />
                <span>DEMAND ANALYSIS</span>
              </a>
            </li>
            <li className={`item forecastingAnalysisParent ${FcModuleStyle['item']} ${isActive === "forecastingAnalysis" ? `${FcModuleStyle['active']}` : ""}`}
              onClick={(e) => {
                handleSetActive(e);
                setIsActive("forecastingAnalysis");
                // e.target.focus();
              }}
              onKeyDown={(e) => {
                if (e.key == "Enter") {
                  e.target.click();
                }
              }}
              // tabIndex={`${isActive === "forecastingAnalysis" ? -1 : 0}`}
              tabIndex={0}>
              <a href={`#forecastingAnalysis`} onClick={forecastingClickHandler} tabIndex={-1}>
                <img src={isActive === "forecastingAnalysis" ? Financial_analysis_active : Financial_analysis_deactive} alt="" />
                <span>FORECASTING ANALYSIS</span>
              </a>
            </li>
          </ul>
        </div>
        <div className={`column ${FcModuleStyle.column} ${FcModuleStyle['summary-content-box']} `} onWheel={handleSetActive} style={{ height: pageHeight + "px" }} >
          <div className={`${FcModuleStyle.section}`} id={`${FcModuleStyle.generalFeedback}`} style={{ "marginTop": "0px" }}>
            <h2>General Feedback</h2>
            <table className={`ui unstackable table ${FcModuleStyle.ui} ${FcModuleStyle.unstackable} ${FcModuleStyle.table}`}>
              <thead>
                <tr>
                  <th id="params" scope="col" className={`two wide ${FcModuleStyle.two} ${FcModuleStyle.wide}`}>Parameters</th>
                  {summaryReports?.GeneralFeedback?.last_forecastedDemands != "NA" ? (
                    <th id="prevSim" scope="col" className={`seven wide right aligned ${FcModuleStyle.seven} ${FcModuleStyle.wide} ${FcModuleStyle.right} ${FcModuleStyle.aligned}`}>
                      Previous Simulation
                    </th>
                  ) : null }
                  <th id="currSim" scope="col" className={`seven wide right aligned ${FcModuleStyle.seven} ${FcModuleStyle.wide} ${FcModuleStyle.right} ${FcModuleStyle.aligned}`}>
                    Current Simulation
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th id="fADemand" colSpan={summaryReports?.GeneralFeedback != undefined && summaryReports?.GeneralFeedback?.last_forecastedDemands !== "NA" ? 3 : 2 } className={`${FcModuleStyle['row-heading']}`}>
                    Forecasted Demand and Actual Demand
                  </th>
                </tr>
                {/* <tr className={`${FcModuleStyle['sub-heading']}`}>
                  <th colSpan={summaryReports?.isLastSimulation ? '' :5}></th>
                  {summaryReports?.isLastSimulation ? 
                  <th colSpan={3} className={`${FcModuleStyle['border-right']}`}>
                    <div className={`${FcModuleStyle.fcGasolineWrapper}`} style={optionsAvailableLength == 1 ? {justifyContent : 'flex-end'} : {}}>
                      {summaryReports?.optionsAvailable?.REGULAR ? <span>Regular</span> : '' }
                      {summaryReports?.optionsAvailable?.MIDGRADE ? <span >Midgrade</span> : '' }
                      {summaryReports?.optionsAvailable?.PREMIUM ? <span>Premium</span> : '' }
                    </div>
                  </th> : ''}
                  <th colSpan={3}>
                    <div className={`${FcModuleStyle.fcGasolineWrapper}`} style={optionsAvailableLength == 1 ? {justifyContent : 'flex-end'} : {}}>
                      { summaryReports?.optionsAvailable?.REGULAR ? <span>Regular</span> : '' }
                      { summaryReports?.optionsAvailable?.MIDGRADE ? <span>Midgrade</span> : '' }
                      { summaryReports?.optionsAvailable?.PREMIUM ? <span>Premium</span> : '' }
                    </div>
                  </th>  
                </tr>
                <tr className={`${FcModuleStyle['indent-row']}`}>
                  <td colSpan={summaryReports?.isLastSimulation ? '' : 5} className={`four wide ${FcModuleStyle.four} ${FcModuleStyle.wide}`}>Forecasted Demand</td>
                  {summaryReports?.isLastSimulation ? 
                    <td colSpan={3} className={`${FcModuleStyle['border-right']}`}>
                      <div className={`${FcModuleStyle.fcGasolineWrapper}`} style={optionsAvailableLength == 1 ? {justifyContent : 'flex-end'} : {}}>
                        {summaryReports?.optionsAvailable?.REGULAR ?
                          <span>{checkNum(Number(summaryReports?.GeneralFeedback?.last_forecastedDemands?.REGULAR))}</span> : '' 
                        }
                        {summaryReports?.optionsAvailable?.MIDGRADE ?
                          <span>{checkNum(Number(summaryReports?.GeneralFeedback?.last_forecastedDemands?.MIDGRADE))}</span> : ''
                        }
                        {summaryReports?.optionsAvailable?.PREMIUM ?
                          <span>{checkNum(Number(summaryReports?.GeneralFeedback?.last_forecastedDemands?.PREMIUM))}</span> : ''
                        }
                      </div>
                    </td> : ''
                  }

                  <td colSpan={3}>
                    <div className={`${FcModuleStyle.fcGasolineWrapper}`} style={optionsAvailableLength == 1 ? {justifyContent : 'flex-end'} : {}}>
                      {summaryReports?.optionsAvailable?.REGULAR ?
                        <span>{checkNum(Number(summaryReports?.GeneralFeedback?.forecastedDemands?.REGULAR))}</span> : ''
                      }
                      {summaryReports?.optionsAvailable?.MIDGRADE ?
                        <span>{checkNum(Number(summaryReports?.GeneralFeedback?.forecastedDemands?.MIDGRADE))}</span>: ''
                      }
                      {summaryReports?.optionsAvailable?.PREMIUM ?
                        <span>{checkNum(Number(summaryReports?.GeneralFeedback?.forecastedDemands?.PREMIUM))}</span> : ''
                      }
                    </div>
                  </td>    
                </tr>
                <tr className={`${FcModuleStyle['indent-row']}`}>
                  <td colSpan={summaryReports?.isLastSimulation ? '' :5} className={`four wide ${FcModuleStyle.four} ${FcModuleStyle.wide}`}>Actual Demand</td>
                  {summaryReports?.isLastSimulation ? 
                    <td colSpan={3} className={`${FcModuleStyle['border-right']}`}>
                      <div className={`${FcModuleStyle.fcGasolineWrapper}`} style={optionsAvailableLength == 1 ? {justifyContent : 'flex-end'} : {}}>
                        {summaryReports?.optionsAvailable?.REGULAR ?
                          <span>{checkNum(Number(summaryReports?.GeneralFeedback?.last_actualDemands?.REGULAR))}</span> : ''
                        }
                        {summaryReports?.optionsAvailable?.MIDGRADE ?
                          <span>{checkNum(Number(summaryReports?.GeneralFeedback?.last_actualDemands?.MIDGRADE))}</span> : ''
                        }
                        {summaryReports?.optionsAvailable?.PREMIUM ?
                          <span>{checkNum(Number(summaryReports?.GeneralFeedback?.last_actualDemands?.PREMIUM))}</span> : ''
                        }
                      </div>
                    </td> : ''
                  }
                  <td colSpan={3}>
                    <div className={`${FcModuleStyle.fcGasolineWrapper}`} style={optionsAvailableLength == 1 ? {justifyContent : 'flex-end'} : {}}>
                      {summaryReports?.optionsAvailable?.REGULAR ?
                        <span>{checkNum(Number(summaryReports?.GeneralFeedback?.actualDemands?.REGULAR))}</span> : ''
                      }
                      {summaryReports?.optionsAvailable?.MIDGRADE ?
                        <span>{checkNum(Number(summaryReports?.GeneralFeedback?.actualDemands?.MIDGRADE))}</span> : ''
                      }
                      {summaryReports?.optionsAvailable?.PREMIUM ?
                        <span>{checkNum(Number(summaryReports?.GeneralFeedback?.actualDemands?.PREMIUM))}</span> : ''
                      }
                    </div>
                  </td>  
                </tr>
                <tr className={`${FcModuleStyle['indent-row']}`}>
                  <td colSpan={summaryReports?.isLastSimulation ? '' :5} className={`four wide ${FcModuleStyle.four} ${FcModuleStyle.wide}`}>MAPE (In %)</td>
                  {summaryReports?.isLastSimulation ? 
                    <td colSpan={3} className={`${FcModuleStyle['border-right']}`}>
                      <div className={`${FcModuleStyle.fcGasolineWrapper}`} style={optionsAvailableLength == 1 ? {justifyContent : 'flex-end'} : {}}>
                        {summaryReports?.optionsAvailable?.REGULAR ?
                          <span>{(checkNum(Number(summaryReports?.GeneralFeedback?.last_mapes?.REGULAR).toFixed(2)))}</span> : ''
                        }
                        {summaryReports?.optionsAvailable?.MIDGRADE ?
                          <span>{(checkNum(Number(summaryReports?.GeneralFeedback?.last_mapes?.MIDGRADE).toFixed(2)))}</span> : ''
                        }
                        {summaryReports?.optionsAvailable?.PREMIUM ?
                          <span>{(checkNum(Number(summaryReports?.GeneralFeedback?.last_mapes?.PREMIUM).toFixed(2)))}</span> : ''
                        }
                      </div>
                    </td> : ''
                  }
                  <td colSpan={3}>
                    <div className={`${FcModuleStyle.fcGasolineWrapper}`} style={optionsAvailableLength == 1 ? {justifyContent : 'flex-end'} : {}}>
                      {summaryReports?.optionsAvailable?.REGULAR ?
                        <span>{(checkNum(Number(summaryReports?.GeneralFeedback?.mapes?.REGULAR).toFixed(2)))}</span> : ''
                      }
                      {summaryReports?.optionsAvailable?.MIDGRADE ?
                        <span>{(checkNum(Number(summaryReports?.GeneralFeedback?.mapes?.MIDGRADE).toFixed(2)))}</span> : ''
                      }
                      {summaryReports?.optionsAvailable?.PREMIUM ?
                        <span>{(checkNum(Number(summaryReports?.GeneralFeedback?.mapes?.PREMIUM).toFixed(2)))}</span> : ''
                      }
                    </div>
                  </td>  
                </tr> */}
                <tr>
                  <td className={`${FcModuleStyle["nested-td"]}`} colSpan={summaryReports?.GeneralFeedback != undefined && summaryReports?.GeneralFeedback?.last_forecastedDemands !== "NA" ? 3 : 2 }>
                    <table className={`${FcModuleStyle["nested-table"]}`}>
                      <thead>
                        <tr className={`${FcModuleStyle["indent-row"]} ${FcModuleStyle["indent-row1"]} `}>
                          <th className={`four wide ${FcModuleStyle.wide}`}></th>
                          {/* Regular, Midgrade, Premium headers for Previous Simulation */}
                          {summaryReports?.isLastSimulation ?  (
                            <>
                            {summaryReports?.optionsAvailable?.REGULAR ? (
                              <th id="prevReg" headers="prevSim" scope="col" className={`one wide ${FcModuleStyle.wide}`}>
                                Regular
                              </th>
                              ) : null}
                              {summaryReports?.optionsAvailable?.MIDGRADE ? (
                              <th id="prevMid" headers="prevSim" scope="col" className={`one wide ${FcModuleStyle.wide}`}>
                                Midgrade
                              </th>
                              ) : null}
                              {summaryReports?.optionsAvailable?.PREMIUM ? (
                              <th id="prevPre" headers="prevSim" scope="col" className={`one wide ${FcModuleStyle.wide} ${FcModuleStyle["border-right"]}`}>
                                Premium
                              </th>
                              ) : null}
                            </>
                          ) : null }
                          {/* Regular, Midgrade, Premium headers for Current Simulation */}
                          {summaryReports?.optionsAvailable?.REGULAR ? (
                          <th id="currReg" headers="currSim" scope="col" className={`one wide ${FcModuleStyle.wide}`}>
                            Regular
                          </th>
                          ) : null}
                          {summaryReports?.optionsAvailable?.MIDGRADE ? (
                          <th id="currMid" headers="currSim" scope="col" className={`one wide ${FcModuleStyle.wide}`}>
                            Midgrade
                          </th>
                          ) : null}
                          {summaryReports?.optionsAvailable?.PREMIUM ? (
                          <th id="currPre" headers="currSim" scope="col" className={`one wide ${FcModuleStyle.wide}`}>
                            Premium
                          </th>
                          ) : null}
                        </tr>
                      </thead>
                      <tbody>
                        {/* Forecasted Demand Row */}
                        <tr className={`${FcModuleStyle['indent-row']}`}>
                          <th hedaers="fADemand" className={`four wide ${FcModuleStyle.wide}`} scope="row">
                            Forecasted Demand
                          </th>

                         {summaryReports?.isLastSimulation ? ( 
                          <>
                           {summaryReports?.optionsAvailable?.REGULAR ? (
                            <td headers="prevReg prevSim" className={`one wide ${FcModuleStyle.wide}`}>
                              {checkNum(Number(summaryReports?.GeneralFeedback?.last_forecastedDemands?.REGULAR))}
                            </td>
                           ) : null}
                           {summaryReports?.optionsAvailable?.MIDGRADE ? (
                            <td headers="prevMid prevSim" className={`one wide ${FcModuleStyle.wide}`}>
                              {checkNum(Number(summaryReports?.GeneralFeedback?.last_forecastedDemands?.MIDGRADE))}
                            </td>
                            ) : null}
                            {summaryReports?.optionsAvailable?.PREMIUM ? (
                            <td headers="prevPre prevSim" className={`one wide ${FcModuleStyle.wide} ${FcModuleStyle["border-right"]}`}>
                              {checkNum(Number(summaryReports?.GeneralFeedback?.last_forecastedDemands?.PREMIUM))}
                            </td>
                            ) : null}
                          </> 
                          ) : null}
                          
                          {summaryReports?.optionsAvailable?.REGULAR ? (
                          <td headers="currReg currSim" className={`one wide ${FcModuleStyle.wide}`}>
                            {checkNum(Number(summaryReports?.GeneralFeedback?.forecastedDemands?.REGULAR))}
                          </td>
                           ) : null}
                          {summaryReports?.optionsAvailable?.MIDGRADE ? (
                          <td headers="currMid currSim" className={`one wide ${FcModuleStyle.wide}`}>
                            {checkNum(Number(summaryReports?.GeneralFeedback?.forecastedDemands?.MIDGRADE))}
                          </td>
                           ) : null}
                          {summaryReports?.optionsAvailable?.PREMIUM ? (
                          <td headers="currPre currSim" className={`one wide ${FcModuleStyle.wide}`}>
                            {checkNum(Number(summaryReports?.GeneralFeedback?.forecastedDemands?.PREMIUM))}
                          </td>
                           ) : null}
                        </tr>
                        {/* Actual Demand Row */}
                        <tr className={`${FcModuleStyle['indent-row']}`}>
                          <th hedaers="fADemand" className={`four wide ${FcModuleStyle.wide}`} scope="row">
                            Actual Demand
                          </th>
                          {summaryReports?.isLastSimulation ? ( 
                            <> 
                            {summaryReports?.optionsAvailable?.REGULAR ? (
                              <td headers="prevReg prevSim" className={`one wide ${FcModuleStyle.wide}`}>
                              {checkNum(Number(summaryReports?.GeneralFeedback?.last_actualDemands?.REGULAR))}
                              </td>
                              ) : null}
                              {summaryReports?.optionsAvailable?.MIDGRADE ? (
                              <td headers="prevMid prevSim" className={`one wide ${FcModuleStyle.wide}`}>
                              {checkNum(Number(summaryReports?.GeneralFeedback?.last_actualDemands?.MIDGRADE))}
                              </td>
                              ) : null}
                              {summaryReports?.optionsAvailable?.PREMIUM ? (
                              <td headers="prevPre prevSim" className={`one wide ${FcModuleStyle.wide} ${FcModuleStyle["border-right"]}`}>
                              {checkNum(Number(summaryReports?.GeneralFeedback?.last_actualDemands?.PREMIUM))}
                              </td>
                              ) : null}
                            </>
                          ) : null}

                          {summaryReports?.optionsAvailable?.REGULAR ? (
                          <td headers="currReg currSim" className={`one wide ${FcModuleStyle.wide}`}>
                          {checkNum(Number(summaryReports?.GeneralFeedback?.actualDemands?.REGULAR))}
                          </td>
                          ) : null}
                          {summaryReports?.optionsAvailable?.MIDGRADE ? (
                          <td headers="currMid currSim" className={`one wide ${FcModuleStyle.wide}`}>
                          {checkNum(Number(summaryReports?.GeneralFeedback?.actualDemands?.MIDGRADE))}
                          </td>
                          ) : null}
                          {summaryReports?.optionsAvailable?.PREMIUM ? (
                          <td headers="currPre currSim" className={`one wide ${FcModuleStyle.wide}`}>
                          {checkNum(Number(summaryReports?.GeneralFeedback?.actualDemands?.PREMIUM))}
                          </td>
                          ) : null}
                        </tr>
                        {/* MAPE (In %) Row */}
                        <tr className={`${FcModuleStyle['indent-row']}`}>
                          <th hedaers="fADemand" className={`four wide ${FcModuleStyle.wide}`} scope="row">
                            MAPE (In %)
                          </th>
                          {summaryReports?.isLastSimulation ? ( 
                            <>
                            {summaryReports?.optionsAvailable?.REGULAR ? (
                              <td headers="prevReg prevSim" className={`one wide ${FcModuleStyle.wide}`}>
                              {(checkNum(Number(summaryReports?.GeneralFeedback?.last_mapes?.REGULAR).toFixed(2)))}
                              </td>
                              ) : null}
                              {summaryReports?.optionsAvailable?.MIDGRADE ? (
                              <td headers="prevMid prevSim" className={`one wide ${FcModuleStyle.wide}`}>
                              {(checkNum(Number(summaryReports?.GeneralFeedback?.last_mapes?.MIDGRADE).toFixed(2)))}
                              </td>
                              ) : null}
                              {summaryReports?.optionsAvailable?.PREMIUM ? (
                              <td headers="prevPre prevSim" className={`one wide ${FcModuleStyle.wide} ${FcModuleStyle["border-right"]}`}>
                              {(checkNum(Number(summaryReports?.GeneralFeedback?.last_mapes?.PREMIUM).toFixed(2)))}
                              </td>
                              ) : null}
                            </>
                          ) : null}

                          {summaryReports?.optionsAvailable?.REGULAR ? (
                          <td headers="currReg currSim" className={`one wide ${FcModuleStyle.wide}`}>
                          {(checkNum(Number(summaryReports?.GeneralFeedback?.mapes?.REGULAR).toFixed(2)))}
                          </td>
                          ) : null}
                          {summaryReports?.optionsAvailable?.MIDGRADE ? (
                          <td headers="currMid currSim" className={`one wide ${FcModuleStyle.wide}`}>
                          {(checkNum(Number(summaryReports?.GeneralFeedback?.mapes?.MIDGRADE).toFixed(2)))}
                          </td>
                          ) : null}
                          {summaryReports?.optionsAvailable?.PREMIUM ? (
                          <td headers="currPre currSim" className={`one wide ${FcModuleStyle.wide}`}>
                          {(checkNum(Number(summaryReports?.GeneralFeedback?.mapes?.PREMIUM).toFixed(2)))}
                          </td>
                          ) : null}
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
                <tr>
                  <td className={`${FcModuleStyle['text-td']}`} colSpan={summaryReports?.GeneralFeedback?.last_forecastedDemands !== "NA" ? 3 : 2 }>
                    {summaryReports?.GeneralFeedback?.forecastedDemandMsg}
                  </td>
                </tr>
                <tr>
                  <th id="mapeGoal" colSpan={summaryReports?.GeneralFeedback != undefined && summaryReports?.GeneralFeedback?.last_forecastedDemands !== "NA" ? 3 : 2 } className={`${FcModuleStyle['row-heading']}`}>
                    MAPE Goal
                  </th>
                </tr>
                <tr className={`${FcModuleStyle['indent-row']}`}>
                  <th id="ovralMapePer" headers="mapeGoal" className={`four wide ${FcModuleStyle.four} ${FcModuleStyle.wide}`}>Overall MAPE (%)</th>
                  {summaryReports?.GeneralFeedback?.last_overallMape != "NA" ? (
                    <td headers="mapeGoal ovralMapePer prevSim" className={`six wide right aligned ${FcModuleStyle.six} ${FcModuleStyle.wide} ${FcModuleStyle.right} ${FcModuleStyle.aligned}`}>
                      {(checkNum(Number(summaryReports?.GeneralFeedback?.last_overallMape).toFixed(2)))}
                    </td>
                  ) : null}
                  <td headers="mapeGoal ovralMapePer currSim" className={`six wide right aligned ${FcModuleStyle.six} ${FcModuleStyle.wide} ${FcModuleStyle.right} ${FcModuleStyle.aligned}`}>
                    {(checkNum(Number(summaryReports?.GeneralFeedback?.overallMape).toFixed(2)))}
                  </td>
                </tr>
                <tr>
                  <td headers="mapeGoal" className={`${FcModuleStyle['text-td']}`} colSpan={summaryReports?.GeneralFeedback?.last_forecastedDemands !== "NA" ? 3 : 2 }>
                    {summaryReports?.GeneralFeedback?.mapeGoalMsg}
                  </td>
                </tr>
                <tr>
                  <th id="ovralResult" colSpan={summaryReports?.GeneralFeedback != undefined && summaryReports?.GeneralFeedback?.last_forecastedDemands !== "NA" ? 3 : 2 } className={`${FcModuleStyle['row-heading']}`}>
                    Overall Results
                  </th>
                </tr>
                <tr className={`${FcModuleStyle['indent-row']}`}>
                  <th id="crStatus" headers="ovralResult" className={`two wide ${FcModuleStyle.two} ${FcModuleStyle.wide}`}>Contract Renewal Status</th>
                  {summaryReports?.GeneralFeedback?.last_performanceMsg != "NA" ? (
                    <td headers="ovralResult crStatus prevSim" className={`seven wide left aligned ${FcModuleStyle.seven} ${FcModuleStyle.wide} ${FcModuleStyle.left} ${FcModuleStyle.aligned} ${FcModuleStyle['p-text']}`}>
                      {summaryReports?.GeneralFeedback?.last_performanceMsg}
                    </td>
                  ) : null}
                  <td headers="ovralResult crStatus currSim" className={`seven wide left aligned ${FcModuleStyle.seven} ${FcModuleStyle.wide} ${FcModuleStyle.left} ${FcModuleStyle.aligned} ${FcModuleStyle['p-text']}`}>
                    {summaryReports?.GeneralFeedback?.performanceMsg}
                  </td>
                </tr>
                <tr>
                  <th id="msgNotfcn" colSpan={summaryReports?.GeneralFeedback != undefined && summaryReports?.GeneralFeedback?.last_forecastedDemands !== "NA" ? 3 : 2 } className={`${FcModuleStyle['row-heading']}`}>
                    Messages and Notifications
                  </th>
                </tr>
                <tr>
                  <td headers="msgNotfcn" className={`${FcModuleStyle['text-td']}`} colSpan={summaryReports?.GeneralFeedback?.last_forecastedDemands !== "NA" ? 3 : 2 }>
                      {summaryReports?.GeneralFeedback?.ReadArtifact}
                      {summaryReports?.GeneralFeedback?.RemaingArtifactVedict}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className={`${FcModuleStyle.section} ${FcModuleStyle['demand-analysis-div']}`} id={`demandAnalysis`}>
            <h2 className={`ui header ${FcModuleStyle.ui} ${FcModuleStyle.header}`}>Demand Analysis</h2>
            <div className={`${FcModuleStyle['demand-container']}`}>
              <div className={`${FcModuleStyle['demand-graph-container']}`}>
                <DemandAnalysis summaryReports={summaryReports}></DemandAnalysis>
                <div className={`${FcModuleStyle['DemandAnalysis-legends']}`}>
                  <div className={`${FcModuleStyle['DA-Demand1']}`}><span className={`${FcModuleStyle['DemandAnalysispattern']}`} aria-hidden="true" role="presentation"><div className={`${FcModuleStyle['DemandAnalysis-legend-sign1']}`}></div></span>Forecasted Demand</div>
                  <div className={`${FcModuleStyle['DA-Demand2']}`}><span className={`${FcModuleStyle['DemandAnalysispattern']}`} aria-hidden="true" role="presentation"><div className={`${FcModuleStyle['DemandAnalysis-legend-sign2']}`}></div></span>Actual Demand</div>
                </div>
              </div>
              <div className={`${FcModuleStyle['demand-tbl-container']}`}>
                <table className={`ui celled unstackable table ${FcModuleStyle.ui} ${FcModuleStyle.celled} ${FcModuleStyle.unstackable} ${FcModuleStyle.table} ${FcModuleStyle['demand-tbl']}`}>
                  <thead>
                    <tr>
                      <th>Gasoline Type</th>
                      <th>Forecasted Demand</th>
                      <th>Actual Demand</th>
                    </tr></thead>
                  <tbody>
                    {summaryReports?.optionsAvailable?.REGULAR ? (
                    <tr>
                      <th className={`${FcModuleStyle['gasoline-type']}`}>Regular</th>
                      <td>{checkNum(Number(summaryReports?.DemandAnalysis?.forecastedDemands?.REGULAR))}</td>
                      <td>{checkNum(Number(summaryReports?.DemandAnalysis?.actualDemands?.REGULAR))}</td>
                    </tr>
                    ) : ""}
                    {summaryReports?.optionsAvailable?.MIDGRADE ? (
                    <tr>
                      <th className={`${FcModuleStyle['gasoline-type']}`}>Midgrade</th>
                      <td>{checkNum(Number(summaryReports?.DemandAnalysis?.forecastedDemands?.MIDGRADE))}</td>
                      <td>{checkNum(Number(summaryReports?.DemandAnalysis?.actualDemands?.MIDGRADE))}</td>
                    </tr>
                    ) : ""}
                    {summaryReports?.optionsAvailable?.PREMIUM ? (
                    <tr>
                      <th className={`${FcModuleStyle['gasoline-type']}`}>Premium</th>
                      <td>{checkNum(Number(summaryReports?.DemandAnalysis?.forecastedDemands?.PREMIUM))}</td>
                      <td>{checkNum(Number(summaryReports?.DemandAnalysis?.actualDemands?.PREMIUM))}</td>
                    </tr>
                    ) : ""}
                  </tbody>
                </table>
              </div>
            </div>
            <div className={`${FcModuleStyle['mape-container']}`}>
              <div className={`${FcModuleStyle['mape-graph-container']}`}>
                <MeanAPEGraph summaryReports={summaryReports}></MeanAPEGraph>
                <div className={`${FcModuleStyle['DemandAnalysis-legends']}`}>
                  <div className={`${FcModuleStyle['DA-1']}`}><span className={`${FcModuleStyle['DemandAnalysispattern']}`} aria-hidden="true" role="presentation"><div className={`${FcModuleStyle['DemandAnalysis-legend-sign1']}`}></div></span>{currentYear}-{currentYear + 1}</div>
                  <div className={`${FcModuleStyle['DA-2']}`}><span className={`${FcModuleStyle['DemandAnalysispattern']}`} aria-hidden="true" role="presentation"><div className={`${FcModuleStyle['DemandAnalysis-legend-sign2']}`}></div></span>{currentYear + 1}-{currentYear + 2}</div>
                </div>
              </div>
              <div className={`${FcModuleStyle['mape-tbl-container']}`}>
                <table className={`ui celled unstackable table ${FcModuleStyle.ui} ${FcModuleStyle.celled} ${FcModuleStyle.unstackable} ${FcModuleStyle.table} ${FcModuleStyle['mape-tbl']}`}>
                  <thead>
                    <tr>
                      <th>Gasoline Type</th>
                      <th>MAPE {currentYear}-{currentYear + 1}</th>
                      <th>MAPE {currentYear + 1}-{currentYear + 2}</th>
                    </tr></thead>
                  <tbody>
                  {summaryReports?.optionsAvailable?.REGULAR ? (
                    <tr>
                      <th className={`${FcModuleStyle['gasoline-type']}`}>Regular</th>
                      <td>{(checkNum(Number(summaryReports?.DemandAnalysis?.currentYearMapeValue?.REGULAR).toFixed(2)))}</td>
                      <td>{(checkNum(Number(summaryReports?.DemandAnalysis?.nextYearMapeValue?.REGULAR).toFixed(2)))}</td>
                    </tr>
                  ) : ""}
                  {summaryReports?.optionsAvailable?.MIDGRADE ? (
                    <tr>
                      <th className={`${FcModuleStyle['gasoline-type']}`}>Midgrade</th>
                      <td>{(checkNum(Number(summaryReports?.DemandAnalysis?.currentYearMapeValue?.MIDGRADE).toFixed(2)))}</td>
                      <td>{(checkNum(Number(summaryReports?.DemandAnalysis?.nextYearMapeValue?.MIDGRADE).toFixed(2)))}</td>
                    </tr>
                  ) : ""}
                  {summaryReports?.optionsAvailable?.PREMIUM ? (
                    <tr>
                      <th className={`${FcModuleStyle['gasoline-type']}`}>Premium</th>
                      <td>{(checkNum(Number(summaryReports?.DemandAnalysis?.currentYearMapeValue?.PREMIUM).toFixed(2)))}</td>
                      <td>{(checkNum(Number(summaryReports?.DemandAnalysis?.nextYearMapeValue?.PREMIUM).toFixed(2)))}</td>
                    </tr>
                  ) : ""}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div className={`${FcModuleStyle.section} ${FcModuleStyle['forecasting-analysis-div']}`} id={`forecastingAnalysis`}>
            <h2 className={`ui header ${FcModuleStyle.ui} ${FcModuleStyle.header}`}>Forecasting Analysis</h2>
            { summaryReports?.optionsAvailable?.REGULAR ? (
              <div className={`ui container ${FcModuleStyle.ui} ${FcModuleStyle.container} ${FcModuleStyle['forecasting-analysis-inner-container']}`}>
                <h3>Regular</h3>
                <div className={`${FcModuleStyle['parent-verdict']}`}>
                  <div className={`left aligned ${FcModuleStyle.left} ${FcModuleStyle.aligned} ${FcModuleStyle['verdict-container']}`}>
                    <h4>Verdict for Regular Gasoline</h4>
                    <ul>
                      <li>{(checkNum(Number(summaryReports?.ForecastingAnalysis?.regularGasoline?.GREAT_FORECAST).toFixed(2)))}% of the forecasted demand was excellent.</li>
                      <li>{(checkNum(Number(summaryReports?.ForecastingAnalysis?.regularGasoline?.GOOD_FORECAST).toFixed(2)))}% of the forecasted demand was acceptable.</li>
                      <li>{(checkNum(Number(summaryReports?.ForecastingAnalysis?.regularGasoline?.BAD_FORECAST).toFixed(2)))}% of the forecasted demand was unacceptable.</li>
                    </ul>
                  </div>

                  <div className={`${FcModuleStyle['graph-container']}`}>

                    <CostAnalysisGraph graphdata={summaryReports?.ForecastingAnalysis?.regularGasoline} id={"graph1"}></CostAnalysisGraph>
                    <div className={`${FcModuleStyle['ForecastingType-legends']}`}>
                  <div className={`${FcModuleStyle['FC-Great']}`}><span className={`${FcModuleStyle['ForecastingTypepattern']}`} aria-hidden="true" role="presentation"><div className={`${FcModuleStyle['Great-legend-sign1']}`}></div></span>Great Forecasting</div>
                  <div className={`${FcModuleStyle['FC-Good']}`}><span className={`${FcModuleStyle['ForecastingTypepattern']}`} aria-hidden="true" role="presentation"><div className={`${FcModuleStyle['Good-legend-sign2']}`}></div></span>Good Forecasting</div>
                  <div className={`${FcModuleStyle['FC-Bad']}`}><span className={`${FcModuleStyle['ForecastingTypepattern']}`} aria-hidden="true" role="presentation"><div className={`${FcModuleStyle['Bad-legend-sign3']}`}></div></span>Bad Forecasting</div>
                </div>
                  </div>
                </div>
              </div>
            ) : ""}
            {summaryReports?.optionsAvailable?.MIDGRADE ? ( 
              <div className={`ui container ${FcModuleStyle.ui} ${FcModuleStyle.container} ${FcModuleStyle['forecasting-analysis-inner-container']}`}>
                <h3>Midgrade</h3>
                <div className={`${FcModuleStyle['parent-verdict']}`}>
                  <div className={`left aligned ${FcModuleStyle.left} ${FcModuleStyle.aligned} ${FcModuleStyle['verdict-container']}`}>
                    <h4>Verdict for Midgrade Gasoline</h4>
                    <ul>
                      <li>{(checkNum(Number(summaryReports?.ForecastingAnalysis?.midgradeGasoline?.GREAT_FORECAST).toFixed(2)))}% of the forecasted demand was excellent.</li>
                      <li>{(checkNum(Number(summaryReports?.ForecastingAnalysis?.midgradeGasoline?.GOOD_FORECAST).toFixed(2)))}% of the forecasted demand was acceptable.</li>
                      <li>{(checkNum(Number(summaryReports?.ForecastingAnalysis?.midgradeGasoline?.BAD_FORECAST).toFixed(2)))}% of the forecasted demand was unacceptable.</li>
                    </ul>
                  </div>
                  <div className={`${FcModuleStyle['graph-container']}`}>
                    <CostAnalysisGraph graphdata={summaryReports?.ForecastingAnalysis?.midgradeGasoline} id={"graph2"}></CostAnalysisGraph>
                    <div className={`${FcModuleStyle['ForecastingType-legends']}`}>
                  <div className={`${FcModuleStyle['FC-Great']}`}><span className={`${FcModuleStyle['ForecastingTypepattern']}`} aria-hidden="true" role="presentation"><div className={`${FcModuleStyle['Great-legend-sign1']}`}></div></span>Great Forecasting</div>
                  <div className={`${FcModuleStyle['FC-Good']}`}><span className={`${FcModuleStyle['ForecastingTypepattern']}`} aria-hidden="true" role="presentation"><div className={`${FcModuleStyle['Good-legend-sign2']}`}></div></span>Good Forecasting</div>
                  <div className={`${FcModuleStyle['FC-Bad']}`}><span className={`${FcModuleStyle['ForecastingTypepattern']}`} aria-hidden="true" role="presentation"><div className={`${FcModuleStyle['Bad-legend-sign3']}`}></div></span>Bad Forecasting</div>
                </div>
                  </div>
                </div>
              </div>
            ) : ""}
            {summaryReports?.optionsAvailable?.PREMIUM ? (
              <div className={`ui container ${FcModuleStyle.ui} ${FcModuleStyle.container} ${FcModuleStyle['forecasting-analysis-inner-container']}`}>
                <h3>Premium</h3>
                <div className={`${FcModuleStyle['parent-verdict']}`}>
                  <div className={`left aligned ${FcModuleStyle.left} ${FcModuleStyle.aligned} ${FcModuleStyle['verdict-container']}`}>
                    <h4>Verdict for Premium Gasoline</h4>
                    <ul>
                      <li>{(checkNum(Number(summaryReports?.ForecastingAnalysis?.premiumGasoline?.GREAT_FORECAST).toFixed(2)))}% of the forecasted demand was excellent.</li>
                      <li>{(checkNum(Number(summaryReports?.ForecastingAnalysis?.premiumGasoline?.GOOD_FORECAST).toFixed(2)))}% of the forecasted demand was acceptable.</li>
                      <li>{(checkNum(Number(summaryReports?.ForecastingAnalysis?.premiumGasoline?.BAD_FORECAST).toFixed(2)))}% of the forecasted demand was unacceptable.</li>
                    </ul>
                  </div>
                  <div className={`${FcModuleStyle['graph-container']}`}>
                    <CostAnalysisGraph graphdata={summaryReports?.ForecastingAnalysis?.premiumGasoline} id={"graph3"}></CostAnalysisGraph>
                    <div className={`${FcModuleStyle['ForecastingType-legends']}`}>
                  <div className={`${FcModuleStyle['FC-Great']}`}><span className={`${FcModuleStyle['ForecastingTypepattern']}`} aria-hidden="true" role="presentation"><div className={`${FcModuleStyle['Great-legend-sign1']}`}></div></span>Great Forecasting</div>
                  <div className={`${FcModuleStyle['FC-Good']}`}><span className={`${FcModuleStyle['ForecastingTypepattern']}`} aria-hidden="true" role="presentation"><div className={`${FcModuleStyle['Good-legend-sign2']}`}></div></span>Good Forecasting</div>
                  <div className={`${FcModuleStyle['FC-Bad']}`}><span className={`${FcModuleStyle['ForecastingTypepattern']}`} aria-hidden="true" role="presentation"><div className={`${FcModuleStyle['Bad-legend-sign3']}`}></div></span>Bad Forecasting</div>
                </div>
                  </div>
                </div>
              </div>
            ) : ""}
          </div>
        </div>
        <div className={`${FcModuleStyle['summary-footer']}`}>
          {
            !(attempt != undefined && user_id != undefined) && <div className={`${FcModuleStyle['summary-btn-container']}`}>
              <Button btnName="BACK TO SIMULATION" btnId="backToSimulationBtn" customBtnStyle={summaryBtnStyle} clickEventHandler={navigateToSimulation} />
              {
                summaryReports.nextattempt ? (<Button btnName="START OVER" btnId="startOverBtn" customBtnStyle={summaryBtnStyle} clickEventHandler={startOverSimulation} />)
                  : (<span style={{ 'display': 'flex' }}><img src={info} alt="info" /><em>You do not have any remaining attempts.</em></span>)
              }
              <Button btnName="DONE" btnId="doneBtn" customBtnStyle={summaryBtnStyle} clickEventHandler={handlePopupExitSim} />
            </div>
          }
        </div>
      </div>
    </motion.div>
  );
};

export default Summary;